import { useShallow } from 'zustand/react/shallow';
import { useProductDetailsMedias as useProductDetailsMediasQuery } from '../../../../services/modules/productDetails/productDetails.queries';
import useProductDetailsStore from '../../../../stores/ProductDetails/productDetails.store';
import useIsAdminSeller from '../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import { resolveMediaColor } from '../utils/productDetailsMedias.utils';

const useProductDetailsMedias = () => {
  const isAdminSeller = useIsAdminSeller();
  const {
    productId,
    detailsProductColorId,
    gridProductColorId,
    mediaProductColorId,
    setMediaProductColorId,
  } = useProductDetailsStore(
    useShallow((state) => ({
      productId: state.productDetailsModalState.productId,
      detailsProductColorId: state.productDetailsModalState.productColorId,
      gridProductColorId: state.productGridParams.productColorId,
      mediaProductColorId: state.mediaProductColorId,
      setMediaProductColorId: state.setMediaProductColorId,
    })),
  );

  const { data, isLoading } = useProductDetailsMediasQuery(
    { productId: productId as string, isAdminSeller },
    { enabled: !!productId },
  );

  const colors = data?.colors ?? [];
  const selectedColor = resolveMediaColor({
    colors,
    mediaProductColorId,
    gridProductColorId,
    detailsProductColorId,
  });

  return {
    colors,
    isLoading,
    medias: selectedColor?.medias ?? [],
    selectedProductColorId: selectedColor?.productColorId,
    selectMediaColor: setMediaProductColorId,
  };
};

export default useProductDetailsMedias;
